export default __webpack_public_path__ + "static/media/vanicreamLiteLotion.96aea9c4.jpg";